<template>
  <div class="cs">
    <el-dialog :visible="visible" @close="handleClose" :close-on-click-modal="false" >
      <div class="interaction-head">{{ chooseTypeDialog.title }}</div>
      <div class="radio-ul">
        <el-radio :class="option.value" v-for="option in chooseTypeDialog.options"
                  v-model="selectedType"
                  border
                  :key="option.value"
                  :label="option.value"
        >{{ option.comment }}
        </el-radio>
        <div></div>
        <div class="bt" @click="submit">确认选择</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {chooseType} from "@/api/kecang";

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    dv: {
      type: String,
      required: true
    },
    chooseTypeDialog: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedType: null
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    async submit() {
      const res = await chooseType(this.dv, this.selectedType);
      if ("A00000" === res.code) {
        this.$message.success("提交成功");
        this.handleClose();
      } else {
        this.$message.error("提交失败");
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  margin: 0 !important;
  background: url("~@/assets/images/index/xian.png") no-repeat #262d40;
  background-size: 100% 100%;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  width: 644px;

  .el-dialog__header {
    padding: 0;
  }
  .el-radio__input{
    opacity: 0;
  }
  .el-radio__label{
    padding-left: 0;
  }
  .el-radio.is-bordered{
    width: calc(33.3% - 11px);
    height: 168px;
    margin: 0;
    border-radius: 12px;
    margin-bottom: 16px;
    padding: 0;
    border: 2px solid #2B3447;
  }
  .el-radio__label{
    margin-top: 110px;
    color: #5F7080;
    font-size: 16px;
    font-weight: bold;
    display: block;
  }
  .radio-ul{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 16px 16px;
    flex-wrap: wrap;
  }
  .CET0{
    background: url("~@/assets/images/index/lx1.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET0.is-checked{
    background: url("~@/assets/images/index/lxx1.png") no-repeat center 16px rgba(191, 77, 77, 0.10);
    background-size: 88px 88px;
    border: 2px solid #BF4D4D;
    .el-radio__label{
      color: #BF4D4D;
    }
  }
  .CET1{
    background: url("~@/assets/images/index/lx2.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET1.is-checked{
    background: url("~@/assets/images/index/lxx2.png") no-repeat center 16px rgba(40, 173, 94, 0.10);
    background-size: 88px 88px;
    border: 2px solid #28AD5E;
    .el-radio__label{
      color: #238E4E;
    }
  }
  .CET2{
    background: url("~@/assets/images/index/lx3.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET2.is-checked{
    background: url("~@/assets/images/index/lxx3.png") no-repeat center 16px rgba(191, 77, 77, 0.10);
    background-size: 88px 88px;
    border: 2px solid #BF4D4D;
    .el-radio__label{
      color: #BF4D4D;
    }
  }
  .CET3{
    background: url("~@/assets/images/index/lx4.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET3.is-checked{
    background: url("~@/assets/images/index/lxx4.png") no-repeat center 16px rgba(40, 173, 94, 0.10);
    background-size: 88px 88px;
    border: 2px solid #28AD5E;
    .el-radio__label{
      color: #238E4E;
    }
  }
  .CET4{
    background: url("~@/assets/images/index/lx5.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET4.is-checked{
    background: url("~@/assets/images/index/lxx5.png") no-repeat center 16px rgba(44, 140, 209, 0.10);
    background-size: 88px 88px;
    border: 2px solid #2C8CD1;
    .el-radio__label{
      color: #2C8CD1;
    }
  }
  .CET5{
    background: url("~@/assets/images/index/lx6.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET5.is-checked{
    background: url("~@/assets/images/index/lxx6.png") no-repeat center 16px rgba(44, 140, 209, 0.10);
    background-size: 88px 88px;
    border: 2px solid #2C8CD1;
    .el-radio__label{
      color: #2C8CD1;
    }
  }
  .CET6{
    background: url("~@/assets/images/index/lx7.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET6.is-checked{
    background: url("~@/assets/images/index/lxx7.png") no-repeat center 16px rgba(191, 77, 77, 0.10);
    background-size: 88px 88px;
    border: 2px solid #BF4D4D;
    .el-radio__label{
      color: #BF4D4D;
    }
  }
  .CET7{
    background: url("~@/assets/images/index/lx1.png") no-repeat center 16px #2B3447;
    background-size: 88px 88px;
  }
  .CET7.is-checked{
    background: url("~@/assets/images/index/lxx1.png") no-repeat center 16px rgba(191, 77, 77, 0.10);
    background-size: 88px 88px;
    border: 2px solid #BF4D4D;
    .el-radio__label{
      color: #BF4D4D;
    }
  }
  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }
}
.bt-box {
  display: flex;
  align-items: center;
  justify-content: center;

  .bt2 {
    width: 168px;
    height: 44px;
    border-radius: 8px;
  }

  .bt {
    width: 168px;
    height: 44px;
    border-radius: 8px;
    margin: 0;
    margin-left: 16px;
  }
}

.interaction-head {
  font-size: 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/ChooseTypeDialog.vue